export const theme = {
    name: 'FlowCloud',
    author: {
        name: 'Gustavo Arellano',
        profile_url: 'https://www.flowcloud.com.mx'
    }
};
